import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import {
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  CardText,
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
  UncontrolledDropdown,
} from "reactstrap";

function ReportOptions(props) {
  return (
    <React.Fragment>
      <Row className="justify-content-md-center">
        <Col lg={5}>
          <Link to="/reports/income">
            <Card className="my-2" color="success" inverse>
              <CardBody>
                <Row className="align-items-center">
                  <Col sm={10}>
                    <p className="font-size-20">
                      <b>Ingresos</b>
                    </p>

                    <CardText>Generar reporte de ingresos</CardText>
                  </Col>
                  <Col sm={2}>
                    <div className="mt-4 mt-sm-0">
                      <i className="bx bx-dollar bx-lg"></i>
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Link>
        </Col>
        <Col lg={5}>
          <Link to="/reports/account">
            <Card className="my-2" color="danger" inverse>
              <CardBody>
                <Row className="align-items-center">
                  <Col sm={10}>
                    <p className="font-size-20">
                      <b>Cuentas por cobrar</b>
                    </p>
                    <CardText>Generar reporte de cuentas por cobrar</CardText>
                  </Col>
                  <Col sm={2}>
                    <div className="mt-4 mt-sm-0">
                      <i className="bx bx-user-x bx-lg"></i>
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Link>
        </Col>
        <Col lg={5}>
          <Link to="/reports/daily">
            <Card className="my-2" color="info" inverse>
              <CardBody>
                <Row className="align-items-center">
                  <Col sm={10}>
                    <p className="font-size-20">
                      <b>Balance diario</b>
                    </p>
                    <CardText>Generar reporte de balance diario</CardText>
                  </Col>
                  <Col sm={2}>
                    <div className="mt-4 mt-sm-0">
                      <i className="bx bx-chart bx-lg"></i>
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Link>
        </Col>
        <Col lg={5}>
          <Link to="/reports/vehicle">
            <Card className="my-2" color="warning" inverse>
              <CardBody>
                <Row className="align-items-center">
                  <Col sm={10}>
                    <p className="font-size-20">
                      <b>Vehículos</b>
                    </p>
                    <CardText>Generar reporte de vehículos</CardText>
                  </Col>
                  <Col sm={2}>
                    <div className="mt-4 mt-sm-0">
                      <i className="bx bx-car bx-lg"></i>
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Link>
        </Col>
        <Col lg={5}>
          <Link to="/reports/daily_list">
            <Card className="my-2" color="secondary" inverse>
              <CardBody>
                <Row className="align-items-center">
                  <Col sm={10}>
                    <p className="font-size-20">
                      <b>Lista diaria</b>
                    </p>
                    <CardText>Generar lista diaria de firmas</CardText>
                  </Col>
                  <Col sm={2}>
                    <div className="mt-4 mt-sm-0">
                      <i className="bx bx-notepad bx-lg"></i>
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Link>
        </Col>
        <Col lg={5}>
          <Link to="/reports/subproducts">
            <Card className="my-2" color="dark" inverse>
              <CardBody>
                <Row className="align-items-center">
                  <Col sm={10}>
                    <p className="font-size-20">
                      <b>Subproductos</b>
                    </p>
                    <CardText>Generar reporte de subproductos</CardText>
                  </Col>
                  <Col sm={2}>
                    <div className="mt-4 mt-sm-0">
                      <i className="bx bx-receipt bx-lg"></i>
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Link>
        </Col>
      </Row>
    </React.Fragment>
  );
}

export default ReportOptions;
